import React, { useCallback } from 'react';
import SharedFolderDropdown, {
  Props as FolderDropdownProps,
} from '@wix/da-shared-react/pkg/GallectionFolderDropdown';
import { INITIAL_SCROLL_TOP } from '../../../../../UserWidgets/ProfileHero';
import { PERSPECTIVE_CONTAINER_ID } from '../../../../../App/App';

const FolderBarFolderDropdown: React.FC<FolderDropdownProps> = ({
  setSelectedFolderId,
  ...rest
}) => {
  const handleSetSelectedFolderId = useCallback(
    number => {
      const scrollable = document.getElementById(PERSPECTIVE_CONTAINER_ID);
      if (scrollable) {
        scrollable.scrollTop = INITIAL_SCROLL_TOP;
      }
      setSelectedFolderId(number);
    },
    [setSelectedFolderId]
  );

  return (
    <SharedFolderDropdown
      {...rest}
      setSelectedFolderId={handleSetSelectedFolderId}
    />
  );
};
FolderBarFolderDropdown.displayName = 'FolderBarFolderDropdown';

export default FolderBarFolderDropdown;
